import { createContext, useContext } from 'react';

export type StatusCardVariant = 'warning' | 'success' | 'alert';

export interface StatusCardRootContext {
  variant: StatusCardVariant;
}

export const StatusCardRootContext = createContext<
  StatusCardRootContext | undefined
>(undefined);

export function useStatusCardRootContext(): StatusCardRootContext {
  const context = useContext(StatusCardRootContext);

  if (!context) {
    throw new Error(
      'StatusCardRootContext is missing. StatusCard parts must be placed within a <StatusCard.Root>.'
    );
  }

  return context;
}
